export enum CampaignsStatusEnum {
  EM_ANDAMENTO = 7,
  PAUSA_MANUAL = 9,
  RETOMAR = 10,
  AGENDADO = 11,
  FINALIZADO = 14,
  AGUARD_IMPORTACAO = 15,
  ERRO_IMPORTACAO = 16,
}